import { Box } from "@material-ui/core";
import { Select } from "antd";
import React from "react";

// Sits beside the Direct Labor title (saves a full row) so jumping to a week doesn't require
// scrolling through every week first — selecting one scrolls both Direct Labor and Summary to it
// (see useWeeklyEACWeekNavigation).
export default function WeeklyEACWeekPicker({
  weekOptions,
  selectedWeekStartDate,
  onWeekSelect,
}) {
  if (!weekOptions?.length) return null;

  return (
    <Box
      style={{
        marginLeft: "16px",
        display: "flex",
        alignItems: "center",
        paddingBottom: "4px",
      }}
    >
      <span style={{ fontWeight: 600, marginRight: "8px" }}>Week Picker</span>
      <Select
        showSearch
        placeholder="Go to Week"
        style={{ width: "280px" }}
        options={weekOptions}
        value={selectedWeekStartDate || undefined}
        onChange={onWeekSelect}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
      />
    </Box>
  );
}
